import { render, staticRenderFns } from "./ImgSwiper.vue?vue&type=template&id=7f511dd4&scoped=true&"
import script from "./ImgSwiper.vue?vue&type=script&lang=js&"
export * from "./ImgSwiper.vue?vue&type=script&lang=js&"
import style0 from "./ImgSwiper.vue?vue&type=style&index=0&id=7f511dd4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f511dd4",
  null
  
)

export default component.exports